import { mediaQueryLarge, isMobileBreakpoint } from '@theme/utilities';


document.addEventListener("DOMContentLoaded", preventCopyImages);

function preventCopyImages(event) {
    document.addEventListener("contextmenu", handleImageItemClick)
}

function handleImageItemClick(event) {
    const currentItem = event.target.closest("img");
    if (currentItem) {

        event.preventDefault();
    }
}